class FreeBoosters extends HTMLElement {
  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.initSwiper();
      this.initListeners();
    });
  }

  initSwiper() {
    const swiper = new Swiper('.free-boosters__slider-wrapper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      mousewheel: true
    });
  }

  initListeners() {
    const items = this.querySelectorAll('.free-boosters__item');

    if (items.length > 0) {
      items.forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();

          items.forEach((slide) => {
            slide.querySelector('.booster-check').classList.remove('active');
          })

          item.querySelector('.booster-check').classList.add('active');

          this.changeIncludedProducts();
        })
      });
    }
  }

  getActiveItemVariantId() {
    return this.querySelector('.booster-check.active')
      ? this.querySelector('.booster-check.active').closest('.free-boosters__item').dataset.id
      : false
  }

  changeIncludedProducts() {
    const includedProductsComponent = document.querySelector('included-products');

    if (includedProductsComponent) {
      const boosters = includedProductsComponent.getBoosters();
      const activeItemId = this.getActiveItemVariantId();

      if (!boosters.length && !activeItemId) return;

      boosters.forEach(booster => {
        if (!booster.classList.contains('hidden')) {
          booster.classList.add('hidden');
        }
      });

      boosters.forEach(booster => {
        console.log(booster.dataset.productId, activeItemId);
        if (booster.dataset.productId == activeItemId) {
          booster.classList.remove('hidden');
        }
      })
    }
  }
}

customElements.define('free-boosters', FreeBoosters);
